/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceInstanceLogDto
 */
export interface ResourceInstanceLogDto {
    /**
     * The identifier for instances or kubernetes deployments.
     * @type {string}
     * @memberof ResourceInstanceLogDto
     */
    instanceId: string;
    /**
     * The actual log message.
     * @type {string}
     * @memberof ResourceInstanceLogDto
     */
    messages: string;
}

/**
 * Check if a given object implements the ResourceInstanceLogDto interface.
 */
export function instanceOfResourceInstanceLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "instanceId" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function ResourceInstanceLogDtoFromJSON(json: any): ResourceInstanceLogDto {
    return ResourceInstanceLogDtoFromJSONTyped(json, false);
}

export function ResourceInstanceLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceInstanceLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'],
        'messages': json['messages'],
    };
}

export function ResourceInstanceLogDtoToJSON(value?: ResourceInstanceLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'instanceId': value.instanceId,
        'messages': value.messages,
    };
}

